// Defining the action types
export const ADD_SPONSORS = 'ADD_SPONSORS';

export const ADD_MEMBERS = 'ADD_MEMBERS';

export const ADD_FAQS = 'ADD_FAQS';
export const FAQS_LOADING = 'FAQS_LOADING';

export const ADD_VOLUNTEERS = 'ADD_VOLUNTEERS';
export const VOLUNTEERS_LOADING = 'VOLUNTEERS_LOADING';


